@if (columns.length > 0) {
  <app-tree-table
    (focusDateChange)="focusDateChange($event)"
    [actionColumnWidth]="350"
    [columns]="columns"
    [createLabels]="['EMPLOYEES.CREATE_EMPLOYEE', 'EMPLOYEES.CREATE_EMPLOYMENT']"
    [editable]="isTableEditable()"
    [firstColumnFrozen]="true"
    [focusDate]="focusDate"
    [hasFocusDate]="true"
    [headerGroups]="headerGroupColumns"
    [lazy]="true"
    [strictFilterMode]="false"
    [value]="tree"
    #treeTable
    dataKey="employeeId"
    sortField="employeeId"></app-tree-table>
}
